"use client";
import { BlogCard } from "@/components/featured/common";
import Swiper from "@/components/swiper";
import { useLocale } from "next-intl";
import { SwiperSlide } from "swiper/react";

const BlogSection = ({ blogPosts }) => {
  const locale = useLocale();
  return (
    <Swiper
      swiperOptions={{
        slidesPerView: 1,
        breakpoints: {
          640: {
            slidesPerView: 1,
          },
          768: {
            slidesPerView: 3,
          },
          1024: {
            slidesPerView: 3,
          },
        },
        spaceBetween: 16,
        loop: true,
        pagination: {
          clickable: true,
          containerClass: "mt-3 justify-center gap-[10px] flex h-2",
          bulletActiveClass:
            "!bg-primary h-2 w-6 rounded-full transition-colors duration-300",
          bulletClass:
            "bg-background-primary-weak h-2 w-2 !rounded-full transition-all duration-300",
        },
        navigation: false,
      }}
    >
      {blogPosts?.BlogPosts?.map((item) => (
        <SwiperSlide key={item.Id} className="h-auto w-full">
          <BlogCard
            href={item.Link}
            post={{
              id: item.Id,
              Title: item.Title,
              ImageUrl: item.ImageUrl,
              Excerpt: item.Excerpt,
              Author: {
                name: item.Author,
              },
              DateFormatted: item.Date,
              link: item.Link,
              slug: null,
            }}
            dataLayerPayload={{
              event: "custom_event",
              event_category: "click",
              event_action: "cta_click",
              cta_button: item.Title,
              cta_location: "body",
              cta_category: "blog_posts",
              cta_language: locale.toUpperCase(),
            }}
          />
        </SwiperSlide>
      ))}
    </Swiper>
  );
};

export default BlogSection;
